<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'companyView'
}
</script>